export const getConnectedEntityByFeatureId = <TEntity extends { featureId?: string | null }>(
  featureId: string,
  entities?: TEntity[] | null,
): TEntity | undefined => {
  return entities?.find((entity) => entity.featureId === featureId);
};
